import { IQueryParamsBaseRecord, defaultQueryParamsBase } from "common/records/index/QueryParamsBase";
import { Nullable } from "common/types";
import { Record } from "immutable";

export const accessParamsFromJSON = (data: IAccessParamsData) => {
  const record = { ...(data as any) };

  return new AccessParamsRecord(record);
};

export interface IAccessParamsData extends Partial<IQueryParamsBaseRecord> {
  org_name: Nullable<string>;
  userId: number;
}

export interface IAccessParamsRecord extends IQueryParamsBaseRecord {
  org_name: Nullable<string>;
  userId: number;
}

const defaultAccessParams: IAccessParamsRecord = {
  ...defaultQueryParamsBase,
  sort_by: "accesses.sort_order",
  org_name: "",
  userId: 0,
};

export class AccessParamsRecord extends Record(defaultAccessParams) implements IAccessParamsRecord {}
